import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import {  RestorationOccuranceMetricsRecord } from '../../types/records/alarms';
import { AlarmEventsGraphResponse, AlarmEventsResponse, EventFilterDropdownResponse, RestorationOccuranceMetricsResponse } from '../../types';
import { CACHING_TIME } from '@/store/utils';

export const alarmsEndPoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'hesApi'
  >
) => ({
  getRestorationOccuranceMetrics: builder.query<RestorationOccuranceMetricsRecord[], { searchQuery: string }>({
    query: ({ searchQuery }) => ({
      url: `push-data/pull-events/restoration-occurence-metrics${searchQuery}`
    }),
    transformResponse: (
      response: RestorationOccuranceMetricsResponse
    ): RestorationOccuranceMetricsRecord[] => {
      const data = response.data.records;
      return data;
    }
  }),
  
  getAlarmsEventDetails: builder.query<AlarmEventsResponse, { searchQuery: string }>({
    query: ({ searchQuery }) => ({
      url: `push-data/pull-events${searchQuery}`,
      method: "GET",
    }),
    providesTags: ["AlarmEvents"],
    keepUnusedDataFor: CACHING_TIME,
  }),

  getAlarmsEventGraphs: builder.query<AlarmEventsGraphResponse, { searchQuery: string }>({
    query: ({ searchQuery }) => ({
      url: `push-data/pull-events/piechart-view${searchQuery}`,
      method: "GET",
    }),  
  }),

  getEventsFiltersDropdown:builder.query<EventFilterDropdownResponse,{searchQuery:string}>({
    query:({searchQuery})=>({
       url:`push-data/event-code-description-list${searchQuery}`,
    }),
    providesTags:['EventsFilterDropdown']
  })

});